import cookies from "js-cookie";
import { showDialogModal } from "./modal";
import EventBus from "../events/EventBus";
// Поля, в которых пользователь печатает: фокус на чекбоксе или кнопке не мешает показу
const TEXT_FIELD_SELECTOR = 'input:not([type="checkbox"], [type="radio"], [type="button"], [type="submit"], [type="reset"], [type="range"]), textarea, select, [contenteditable]';
/**
 * Промо-окно показывается спустя data-delay мс видимости вкладки после полной
 * загрузки страницы — до тех пор, пока пользователь его не закроет или не перейдёт
 * по ссылке из него. Тогда флаг data-promo-key пишется в localStorage (или в куку, если оно недоступно), поэтому
 * новое промо достаточно завести под новым ключом.
 */
export default function initPromoModal() {
    const content = document.querySelector('.promo-modal[data-promo-key]');
    const modal = content?.closest('dialog.modal');
    const key = content?.dataset.promoKey;
    if (!content || !modal || !key || wasDismissed(key)) {
        return;
    }
    const delay = Number(content.dataset.delay) || 0;
    const open = () => {
        // Окно могли закрыть в другой вкладке, пока шёл отсчёт
        if (wasDismissed(key)) {
            return;
        }
        // Пользователь занят — отсчитываем задержку заново, чтобы окно
        // не всплыло в ту же секунду, как он закроет меню или выйдет из поля
        if (isUserBusy()) {
            runWhileVisible(delay, open);
            return;
        }
        showDialogModal(modal);
    };
    const schedule = () => runWhileVisible(delay, open);
    EventBus.on('modal:close', closedModal => {
        if (closedModal === modal) {
            markDismissed(key);
        }
    });
    // Переход по ссылке из окна не закрывает его, но показывать промо повторно уже незачем
    content.addEventListener('click', event => {
        if (event.target.closest('a[href]')) {
            markDismissed(key);
        }
    });
    if (document.readyState === 'complete') {
        schedule();
    }
    else {
        window.addEventListener('load', schedule, { once: true });
    }
}
// Отсчитывает delay только пока вкладка видима
function runWhileVisible(delay, callback) {
    let remaining = delay;
    let startedAt = 0;
    let timerId;
    const start = () => {
        startedAt = performance.now();
        timerId = window.setTimeout(finish, remaining);
    };
    const pause = () => {
        clearTimeout(timerId);
        remaining -= performance.now() - startedAt;
    };
    const finish = () => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        callback();
    };
    const onVisibilityChange = () => document.hidden ? pause() : start();
    document.addEventListener('visibilitychange', onVisibilityChange);
    if (!document.hidden) {
        start();
    }
}
// Открытая модалка, панель мобильного меню или фокус в текстовом поле
function isUserBusy() {
    return Boolean(document.querySelector('dialog[open]'))
        || Boolean(document.activeElement?.matches(TEXT_FIELD_SELECTOR));
}
function wasDismissed(key) {
    try {
        if (localStorage.getItem(key) !== null) {
            return true;
        }
    }
    catch {
        // Хранилище недоступно — флаг мог быть записан в куку
    }
    return cookies.get(key) !== undefined;
}
function markDismissed(key) {
    try {
        localStorage.setItem(key, '1');
    }
    catch {
        // Хранилище недоступно (приватный режим, переполнение) — запоминаем в куке
        cookies.set(key, '1', { path: '/', expires: 365 });
    }
}
